'use strict';

angular
    .module('AutoPrequal', [
        'snapscroll',
        'ngAnimate',
        'ui.router',
        'ngAria',
        'customHeaders'
    ])
    .config(['$urlRouterProvider', '$stateProvider', '$httpProvider', '$sceDelegateProvider', '$ariaProvider', function ($urlRouterProvider, $stateProvider, $httpProvider, $sceDelegateProvider, $ariaProvider) {
        $sceDelegateProvider.resourceUrlWhitelist([
            // Allow same origin resource loads.
            'self',
            // Allow loading from our assets domain.  Notice the difference between * and **.
            olb_domain + '**'
        ]);

        $httpProvider.interceptors.push('LoadingInterceptor', 'httpRequestInterceptor');

        $urlRouterProvider.otherwise('/main/welcome');

        $ariaProvider.config({
            ariaHidden: true,
            ariaChecked: false,
            ariaReadonly: false,
            ariaDisabled: true,
            ariaRequired: true,
            ariaInvalid: false,
            ariaValue: false,
            tabindex: false,
            bindKeydown: true,
            bindRoleForClick: false
        });

        $stateProvider
            .state('main', {
                url: '/main/:hash',
                params: { hash: { dynamic: true } },
                templateUrl: baseUrl + 'root/app/views/main.html',
                controller: 'mainCtrl',
                controllerAs: 'main',
            })
            .state('results', {
                url: '/results',
                templateUrl: baseUrl + 'root/app/views/results.html',
                controller: 'resultsCtrl',
                controllerAs: 'results',
                title: 'Results',
                titleFr: 'Résultat',
            })
            .state('error', {
                url: '/error',
                templateUrl: baseUrl + 'root/app/views/error.html',
                controller: 'errorCtrl',
                controllerAs: 'error',
                title: 'Error',
                titleFr: 'Erreur',
            })
            .state('maintenance', {
                url: '/maintenance',
                templateUrl: baseUrl + 'root/app/views/maintenance.html',
                controller: 'maintenanceCtrl',
                controllerAs: 'maintenance',
                title: 'Maintenance',
                titleFr: 'Maintenance'
            });

    }])
    .controller('AutoPrequalCtrl', ['$scope', '$rootScope', '$transitions', '$window', '$timeout', '$q', 'SessionFactory', 'ScrollFactory', 'DataFactory', 'ImageFactory', function ($scope, $rootScope, $transitions, $window, $timeout, $q, SessionFactory, ScrollFactory, DataFactory, ImageFactory) {
        $rootScope.loading = true;
        $rootScope.isLoaded = false;
        $rootScope.snapIndex = 0;
        $rootScope.termsAccepted = false;
        $rootScope.keepScrolling = false;
		$rootScope.tradeinHelp = false;
		$rootScope.sideMenuOpen = false;
        $rootScope.currentStep = ScrollFactory.stepNoToName($rootScope.snapIndex);
        $rootScope.pubDomain = pub_domain;
        $rootScope.baseUrl = baseUrl;
        $rootScope.olbDomain = olb_domain;
		$rootScope.validateAllSteps = validateAllSteps;
        $scope.steps = ScrollFactory.steps;
        $scope.checkActive = checkActive;
        $scope.snapscrollEnabled = $window.innerWidth > 680;
        $scope.nextStep = nextStep;
		$scope.cancelApplication = cancelApplication;

        function updateSnapIndexFromHash() {
            var index = parseInt(ScrollFactory.stepNameToNo($window.location.hash.slice(2)), 10);
            if (isNaN(index) || !angular.isNumber(index)) {
                return;
            }
            $rootScope.snapIndex = index;
        }

        function checkActive(event) {
            if (event.currentTarget.className.indexOf('active') === -1) {
                $('section').removeClass('active');
                $(event.currentTarget).addClass('active');
            }
        }

        function nextStep() {
            DataFactory.appData.applicant.appState[$rootScope.currentStep] = true;
            eval('$rootScope.' + $rootScope.currentStep + 'NextStep()');
        }

        function validateAllSteps() {
            $rootScope.validatingAllSteps = true;
            var goToStep = ScrollFactory.goToStep;
            var showStep = ScrollFactory.showStep;
            var setData = DataFactory.setData;
            ScrollFactory.goToStep = function () { };
            ScrollFactory.showStep = function () { };
            DataFactory.setData = function () { };
            var r = true;
            for (var i = 0; i < ScrollFactory.steps.length; i++) {
                if (ScrollFactory.steps[i].display) {
                    if (typeof eval('$rootScope.' + ScrollFactory.steps[i].name + 'NextStep') === "function") {
                        if (!eval('$rootScope.' + ScrollFactory.steps[i].name + 'NextStep()')) {
                            r = false;
                        }
                    }
                }
            }
            //explicit case to check if no for both tax questions since that is not a form
            if (!DataFactory.appData.applicant.apTaxProvince && ((DataFactory.appData.applicant.apTaxCountries && DataFactory.appData.applicant.apTaxCountries.length === 0) || !DataFactory.appData.applicant.apTaxCountries))
                r = false;
            $timeout(function () {
                if (!r && $('.error:visible').first().length) {
                    var errorToScroll = $('.error:visible').first();
                    $rootScope.currentStep = errorToScroll.parents('ng-include').attr('name')
                    $rootScope.scrolling = true;
                    errorToScroll.parents('section').velocity("stop", true).velocity("scroll", {
                        container: $('.container-right'),
                        duration: 500,
                        easing: "easeOutQuad",
                        complete: function (el) {
                            errorToScroll.focus();
                            $(window).trigger('resize');
                            $rootScope.scrolling = false;
                        }
                    });
                }
            })
            ScrollFactory.goToStep = goToStep;
            ScrollFactory.showStep = showStep;
            DataFactory.setData = setData;
            $rootScope.validatingAllSteps = false;
            return r;
        }

        function cancelApplication() {
            SessionFactory.deleteCurrentSession();
            window.location.href = DataFactory.appData.content.glContent.autohub_url;
        }

        function signOut() {
            //'signOutClickedApp' is used to reload the app if the user clicks back after signing out. See config for relavent code
            sessionStorage.setItem('signOutClickedApp', true);
            SessionFactory.deleteCurrentSession();
            window.location = olb_domain + $rootScope.glContent.sign_out_link;
        }
        $rootScope.signOut = signOut;

        //watchers
        $scope.$watch(function () {
            return ScrollFactory.steps;
        }, function (newValue, oldValue) {
            $scope.steps = ScrollFactory.steps;
        });

        //scroll section into view on url change
		$rootScope.$on('$locationChangeSuccess', function (e) {
			if ($(window).width() <= 768) {
				if ($rootScope.mobileOperatingSystem === "iPhone" || $rootScope.mobileOperatingSystem === "iPad") $('body').scrollTop(0);
				else $(window).scrollTop(0);
			}
			if ($('section.' + $rootScope.currentStep).find('h1').first()[0]) {
				$timeout(function () { $('section.' + $rootScope.currentStep).find('h1').first()[0].focus(); })
            }
        })

        //disable state changes from maintenance page
        $transitions.onStart({}, function (transition) {
            $('section.' + $rootScope.currentStep).removeClass('inactive')
            if (transition.from().name === "maintenance") {
                return false;
            }
        });

        $transitions.onSuccess({}, function (transition) {
            if (transition.from().name === "review" && transition.to().name === "main") {
                if (!$rootScope.scrolling && $(window).width() > 680) {
                    $timeout(function () {
                        $rootScope.scrolling = true;
                        $('section.' + $rootScope.currentStep).velocity("stop", true).velocity("scroll", {
                            container: $('.container-right'),
                            duration: 50,
                            complete: function (el) {
                                $rootScope.scrolling = false;
                            }
                        });
                    })
                }
            }
        })

        $transitions.onStart({}, function (transition) {
            var deferred = $q.defer();
            var unwatch = $rootScope.$watch('glContent', function () {
                if ($rootScope.glContent) {
                    unwatch();
                    deferred.resolve();
                }
            })
            return deferred.promise;
        })

        //set page title and cancel ga id
        $transitions.onStart({}, function (transition) {
            var titleParam = $rootScope.lang === 'fr' ? 'titleFr' : 'title';
            if (transition.to().name === 'main') {
                $rootScope.title = $rootScope.stepsMap[transition.params().hash][titleParam];
                $rootScope.titleEN = $rootScope.stepsMap[transition.params().hash]['title'];
            } else {
                $rootScope.title = transition.to()[titleParam];
                $rootScope.titleEN = transition.to()['title'];
            }
        })

        $rootScope.$watch('currentStep', function (newStep, oldStep) {
			if (newStep === 'applicantAddress') {
                $rootScope.drawAddrName();
            }
        })

        updateSnapIndexFromHash();

        //function to write name onto left side image 
        $rootScope.drawAddrName = drawAddrName;

        function drawAddrName() {
            $timeout(function () {
                ImageFactory.drawAddrImages();
            });
        }
    }])
    .run(['$rootScope', '$state', '$q', '$http', '$location', '$window', '$sce', '$timeout', '$interval', 'LocalizationFactory', 'DataFactory', 'ErrorFactory', 'SessionFactory', 'ScrollFactory', '$filter', function ($rootScope, $state, $q, $http, $location, $window, $sce, $timeout, $interval, LocalizationFactory, DataFactory, ErrorFactory, SessionFactory, ScrollFactory, $filter) {
        $rootScope.loading = true;
        $rootScope.lang = incoming_lang || "en";

        //device
        function getMobileOperatingSystem() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if (/windows phone/i.test(userAgent)) {
                return "Windows";
            }
            if (/android/i.test(userAgent)) {
                return "android";
            }
            if (/iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "iPhone";
            }
            if (/iPad/.test(userAgent) && !window.MSStream) {
                return "iPad";
            }
            return "unknown";
        }
        $rootScope.mobileOperatingSystem = getMobileOperatingSystem();

        $rootScope.restart = function () {
            $rootScope.forcedLoader = true;
            SessionFactory.deleteCurrentSession();
            window.location.reload();
        }

        if (sessionStorage.getItem('signOutClickedApp')) {
            sessionStorage.removeItem('signOutClickedApp');
            $rootScope.restart();
		}

		$rootScope.progressStepsDefault = 16; //constant

        $rootScope.progressSteps = $rootScope.progressStepsDefault; //adjust this to adjust progress bar
        $rootScope.progressMobSteps = $rootScope.progressStepsDefault;

        var date = new Date();
        $rootScope.currentYear = date.getFullYear();
        $rootScope.restoreAppState = restoreAppState;
        $rootScope.stepsMap = _.mapKeys(ScrollFactory.steps, function (v, k) { return v.name });

        function restoreAppState() {
            $.each(DataFactory.appData.applicant.appState, function (index, value) {
                if (value) ScrollFactory.showStep(index)
            })
            $timeout(function () {
                ScrollFactory.goToStep(ScrollFactory.getLastStep())
            }, 100);
        }

        function initApp() {
            SessionFactory.getCurrentSession();
            LocalizationFactory.getContent($rootScope.lang).then(function (response) {
                DataFactory.appData.content = response;
                $rootScope.glContent = response.glContent;
                if (app_error) {
                    $rootScope.isLoaded = true;
                    ErrorFactory.errorPage(app_error, "en", "Initialization failed", "Initialization failed");
                    return Promise.reject();
                }
                if (mtnc_on === "true") {
                    $state.go("maintenance");
                    return Promise.reject();
                }
                if (SessionFactory.sessionId) {
                    //retrieve current session
                    $rootScope.isLoadingSession = true;
                    return SessionFactory.retrieveCurrentSession(SessionFactory.sessionId);
                } else {
                    //create new session
                    SessionFactory.deleteCurrentSession();
                    var data = {};
                    return SessionFactory.createSession(data);
                }
            }, function (e) {
                $rootScope.isLoaded = true;
                ErrorFactory.errorPage("LS", $rootScope.lang, "Initialization error", e);
            }).then(function (response) {
                $rootScope.isLoadingSession = false;
                $rootScope.restoreAppState();
            }, function (e) {
                //if (e.message !== "app_error") ErrorFactory.errorPage("SR", $rootScope.lang, "");
            }).catch(function (e) {
                $rootScope.isLoaded = true;
                ErrorFactory.errorPage("GSU", $rootScope.lang, "Initialization error", e);
            });
        }
        initApp();

        $(document).ready(function () {
            if ("ontouchstart" in window || "ontouch" in window) { $('body').addClass('touch'); }
            else { $('body').addClass('no-touch'); }
        });

        $(window).on('resize', function () {

            if ($rootScope.currentStep.indexOf('applicantAddress') > -1 && $rootScope.name) {
                $rootScope.drawAddrName();
            }

            if (!$rootScope.scrolling && $(window).width() > 680) {
                $rootScope.scrolling = true;
                $('section.' + $rootScope.currentStep).velocity("stop", true).velocity("scroll", {
                    container: $('.container-right'),
                    duration: 10,
                    easing: "easeOutQuad",
                    complete: function (el) {
                        $rootScope.scrolling = false;
                    }
                });
            }

        })

    }])
    .filter('trusted', ['$sce', function ($sce) {
        return function (value, type) {
            // Defaults to treating trusted text as `html`
            return $sce.trustAs(type || 'html', value);
        }
    }])
    .filter('currency', ["$rootScope", function ($rootScope) {
        return filter;

        function filter(input, lang) {
            if (!lang) lang = $rootScope.lang || 'en';
            if (input !== null && input !== undefined) {
                if (lang === 'fr') return Number(input).toLocaleString("fr-CA", { style: "currency", currency: "CAD", minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace("CA", "");
				else return Number(input).toLocaleString("en-CA", { style: "currency", currency: "CAD", minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace("CA", "");
            }
        }
    }])
    .filter('phoneno', ["$rootScope", function ($rootScope) {
        return function (input, lang) {
            if (input !== null && input !== undefined) {
                if (!lang) lang = $rootScope.lang || 'en';
                var formatted = "";
                input = input.replace(/[^\/\d]/g, '');
                if (input.length === 11) {
                    var country = input.substring(0, 1);
                    var area = input.substring(1, 4);
                    var front = input.substring(4, 7);
                    var end = input.substring(7, 11);
                    if (lang == "en") {
                        formatted = country + "-" + area + "-" + front + "-" + end;
                    }
                    else formatted = country + " " + area + " " + front + "-" + end;
                }
                else if (input.length === 10) {
                    var area = input.substring(0, 3);
                    var front = input.substring(3, 6);
                    var end = input.substring(6, 10);
                    if (lang == "en") {
                        formatted = area + "-" + front + "-" + end;
                    }
                    else formatted = area + " " + front + "-" + end;
                }
                else formatted = input;
                return formatted;
            }
        }
    }])
    .filter('checkPOBox', function () {
        //return if it's a po box or not
        var boxRegex = /^.*\s*box\s+\d+.*$/i;
        var boxRegex2 = /^.*\s*p\.?o\.?\s*box.*$/i;

        var invalidValues = [
            "PO\\s+Box", "P\\s+O\\s+Box", "P\\.O\\.\\s+Box", "PO\\.\\s+Box", "P\\.O\\s+Box", "Post\\s+Office\\s+Box", "RPO", "General\\s+Delivery", "Gen\\s+Delivery", "GD", "STN\\s+Main", "Station\\s+Main", "STN\\s+DEL\\s+Centre", //en
            "Case\\s+Postale", "CP", "C\\.P\\.", "C\\.P", "CP\\.", "Poste\\s+Restante" //fr
        ]
        var invalidRegex = new RegExp(['(.*?(\\b', invalidValues.join('\\b|\\b'), '\\b)[^$]*)$'].join(''), 'i');
        return function (input) {
            if (!input) return input;

            if (boxRegex.test(input) || boxRegex2.test(input)) {
                return true;
            }
            //additional validation for pjNum 02033
            if (invalidRegex.test(input)) {
                return true;
            }
            return false;
        }
    })
    .filter("postalCode", function () {
        return function (string) {
            if (!string) return string;
            if (string.length < 6) return string;
            return string.substring(0, 3) + "\u00A0" + string.substring(3);
        }
    })
    .filter("readableDOB", ['DataFactory', function (DataFactory) {
        return function (dob) {
            if (!dob || !DataFactory || !DataFactory.appData || !DataFactory.appData.content) return dob;
            var pattern = /(\d{4})-(\d{2})-(\d{2})/;
            dob = new Date(dob.replace(pattern, '$1-$2-$3'));
            var date = dob.getUTCDate();
            date = date < 10 ? '0' + date : date;
            var month = dob.getUTCMonth() + 1;
            month = month < 10 ? '0' + month : month;
            var year = dob.getUTCFullYear();
            return DataFactory.appData.content.month_list[month] + ' ' + date + ' ' + year;
        }
    }])
    .filter("range", function () {
        return function (input, start, end) {
            if (!start || !end) return [];
            var direction;
            start = parseInt(start);
            end = parseInt(end);
            if (start === end) { return [start]; }
            direction = (start <= end) ? 1 : -1;
            while (start != end) {
                input.push(start);
                if (direction < 0 && start === end + 1) {
                    input.push(end);
                }
                if (direction > 0 && start === end - 1) {
                    input.push(end);
                }
                start += direction;
            }
            return input;
        }
    })
    .filter("checkPostalCode", function () {
        if (!String.prototype.startsWith) {
            String.prototype.startsWith = function (searchString, position) {
                position = position || 0;
                return this.indexOf(searchString, position) === position;
            };
        }
        //test pattern
        var regex = /^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/;
        return function (postalCode, province) {
            var isValid = false;
            if (!province || !postalCode) return false;
            if (province) {

                switch (province) {
                    case "AB":
                        if (postalCode.toUpperCase().startsWith("T")) isValid = true;
                        break;
                    case "BC":
                        if (postalCode.toUpperCase().startsWith("V")) isValid = true;
                        break;
                    case "MB":
                        if (postalCode.toUpperCase().startsWith("R")) isValid = true;
                        break;
                    case "NB":
                        if (postalCode.toUpperCase().startsWith("E")) isValid = true;
                        break;
                    case "NL":
                        if (postalCode.toUpperCase().startsWith("A")) isValid = true;
                        break;
                    case "NS":
                        if (postalCode.toUpperCase().startsWith("B")) isValid = true;
                        break;
                    case "NT":
                        if (postalCode.toUpperCase().startsWith("X")) isValid = true;
                        break;
                    case "NU":
                        if (postalCode.toUpperCase().startsWith("X")) isValid = true;
                        break;
                    case "ON":
                        if (postalCode.toUpperCase().startsWith("K") ||
                            postalCode.toUpperCase().startsWith("L") ||
                            postalCode.toUpperCase().startsWith("M") ||
                            postalCode.toUpperCase().startsWith("N") ||
                            postalCode.toUpperCase().startsWith("P")) isValid = true;
                        break;
                    case "PE":
                        if (postalCode.toUpperCase().startsWith("C")) isValid = true;
                        break;
                    case "QC":
                        if (postalCode.toUpperCase().startsWith("G") ||
                            postalCode.toUpperCase().startsWith("H") ||
                            postalCode.toUpperCase().startsWith("J")) isValid = true;
                        break;
                    case "SK":
                        if (postalCode.toUpperCase().startsWith("S")) isValid = true;
                        break;
                    case "YT":
                        if (postalCode.toUpperCase().startsWith("Y")) isValid = true;
                        break;
                    default:
                        break;
                }
            }

            if (!postalCode.match(regex)) isValid = false;
            return isValid;
        }
	}).filter('currencyFormat', ["$rootScope", function ($rootScope) {
		//currency format to allow for dynamic decimal places
		return function (input, lang, noDecimalCheck) {
			//noDecimalCheck only when the user is entering currency into an input box, we don't want to add trailing zeros etc when they're typing. this is set to false in currency-formatter directive
			if (!lang) lang = $rootScope.lang || 'en';
			if (input !== null && input !== "" && input !== undefined && !isNaN(input) && input !== "NaN") {
				if (lang === 'fr') {
					//if it's a decimal we need to ensure it has no more or no less than 2 precision points
					if (((String(input).indexOf(".") > -1 || String(input).indexOf(",") > -1)) && !noDecimalCheck) {
						return Number(input).toLocaleString("fr-CA", { style: "currency", currency: "CAD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
					}
					else {
						return Number(input).toLocaleString("fr-CA", { style: "currency", currency: "CAD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
					}
				}
				else {
					if (((String(input).indexOf(".") > -1 || String(input).indexOf(",") > -1)) && !noDecimalCheck) {
						return Number(input).toLocaleString("en-CA", { style: "currency", currency: "CAD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
					}
					else {
						return Number(input).toLocaleString("en-CA", { style: "currency", currency: "CAD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
					}
				}
			}
		}
	}]);